import React from "react";

/* Stacked under the summary on desktop, fixed to the bottom on mobile. */
const CartActions = ({ translation, onCheckout, onContinueShopping, isCheckoutDisabled }) => (
  <div className="cart-actions">
    <button
      type="button"
      className="cart-btn cart-btn--primary cart-actions__checkout"
      onClick={onCheckout}
      disabled={isCheckoutDisabled}
    >
      <span className="cart-btn__label">{translation?.checkout}</span>
    </button>
    <button
      type="button"
      className="cart-btn cart-btn--outline cart-actions__continue"
      onClick={onContinueShopping}
    >
      <span className="cart-btn__label">{translation?.continueShopping}</span>
    </button>
  </div>
);

export default CartActions;
